import styled from 'styled-components';

export const MediaList = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 12px;
  margin-bottom: 36px;
`;
